<div class="background-location-always">
  <h3 class="background-location-always__title">
    {{ "MODALS.BACKGROUND_LOCATION_ALWAYS.TITLE" | translate }}
  </h3>
  <p class="background-location-always__message">
    {{ "MODALS.BACKGROUND_LOCATION_ALWAYS.MESSAGE" | translate }}
  </p>
  <div class="background-location-always__buttons">
    <app-button
      (onClick)="openSettings()"
      [innerText]="'MODALS.BACKGROUND_LOCATION_ALWAYS.OPEN_SETTINGS' | translate"
    />
    <app-button
      [styles]="{ backgroundColor: '#1D5D9B80' }"
      (onClick)="closeModal()"
      [innerText]="'MODALS.BACKGROUND_LOCATION_ALWAYS.NOT_NOW' | translate"
    />
  </div>
</div>
